var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.2597 7.63271L13.6298 0L0 7.63271L2.72597 9.15351V14.1176C2.18077 14.2324 1.75036 14.7202 1.75036 15.2941C1.75036 15.6384 1.89383 15.9541 2.15208 16.1836L1.75036 19.7131C1.75036 19.7131 2.18077 20 2.95552 20C3.73027 20 4.16069 19.7131 4.16069 19.7131L3.75897 16.1836C3.98852 15.9541 4.16069 15.6384 4.16069 15.2941C4.16069 14.7202 3.75897 14.2324 3.18508 14.1176V9.41176L5.22238 10.5595V8.60832C5.22238 7.05882 9.55524 6.19799 13.6298 6.19799C17.7044 6.19799 22.0373 7.03013 22.0373 8.60832V10.5595L27.2597 7.63271Z",
    fill: "#A9A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.629 12.855C8.95183 12.855 5.68066 13.8593 5.68066 14.7775C5.68066 15.6957 8.95183 16.7 13.629 16.7C18.3062 16.7 21.5774 15.6957 21.5774 14.7775C21.5774 13.888 18.3062 12.855 13.629 12.855Z",
    fill: "#A9A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.629 6.68573C8.95183 6.68573 5.68066 7.69003 5.68066 8.60826V13.9454C6.91452 12.9411 10.3579 12.3959 13.629 12.3959C16.9002 12.3959 20.3435 12.9411 21.5774 13.9454V8.60826C21.5774 7.69003 18.3062 6.68573 13.629 6.68573Z",
    fill: "#A9A7A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradHat);
export default __webpack_public_path__ + "static/media/grad-hat.be9d0e31efdbc0cccbb1896a02e863dd.svg";
export { ForwardRef as ReactComponent };